/* SuperCalm · Luz Regia — comportamiento de la landing (sin Liquid: los assets .js no lo procesan).
   Cada pieza se engancha por data-atributos y solo se ejecuta si está en la página. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ───────────── Carruseles con scroll nativo (mini reseñas, Facebook, vídeos, testimonios) ───────────── */
  function carrusel(root) {
    var track = $('[data-sc-track]', root);
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var prev = $('[data-sc-prev]', root);
    var next = $('[data-sc-next]', root);
    var dots = $('[data-sc-dots]', root);
    var bar = $('[data-sc-progress] i', root);

    function paso() {
      if (items.length < 2) return track.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }
    function indice() { return Math.round(track.scrollLeft / Math.max(1, paso())); }
    function maxIndice() { return Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / Math.max(1, paso()))); }

    if (dots && !dots.children.length) {
      items.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir a la reseña ' + (i + 1));
        b.addEventListener('click', function () { track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); });
        dots.appendChild(b);
      });
    }
    function pintar() {
      var i = indice(), m = maxIndice();
      if (prev) { prev.disabled = track.scrollLeft < 4; if (prev.classList.contains('sc-mini__prev')) prev.style.display = track.scrollLeft < 4 ? 'none' : 'grid'; }
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === Math.min(i, items.length - 1)); });
      if (bar) {
        var vis = Math.max(1, items.length - m);
        bar.style.width = (100 * vis / items.length) + '%';
        bar.style.transform = 'translateX(' + (m ? (100 * i / vis) : 0) + '%)';
      }
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: paso(), behavior: 'smooth' }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
  }

  /* ───────────── Vídeos: póster ligero, el mp4 se carga al pulsar y suena ───────────── */
  function videos() {
    document.addEventListener('click', function (e) {
      var tile = e.target.closest && e.target.closest('.sc-vid[data-src]');
      if (!tile) return;
      var v = $('video', tile);
      if (!v) {
        v = document.createElement('video');
        v.src = tile.getAttribute('data-src');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'auto');
        v.addEventListener('ended', function () { tile.classList.remove('is-playing'); v.currentTime = 0; });
        v.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
        v.addEventListener('play', function () { tile.classList.add('is-playing'); });
        tile.insertBefore(v, tile.firstChild);
      }
      if (v.paused) {
        $$('.sc-vid video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
      } else {
        v.pause();
      }
    });
  }

  /* ───────────── Línea de tiempo de 4 pasos ───────────── */
  function lineaTiempo(root) {
    var steps = $$('.sc-tl__step', root), panels = $$('.sc-tl__panel', root);
    var prev = $('[data-tl-prev]', root), next = $('[data-tl-next]', root), cnt = $('.sc-tl__count', root), bar = $('.sc-tl__bar', root);
    var i = 0;
    function ir(n) {
      i = Math.max(0, Math.min(steps.length - 1, n));
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.classList.toggle('is-done', k < i); s.setAttribute('aria-selected', k === i); });
      panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === steps.length - 1;
      if (cnt) cnt.textContent = (i + 1) + ' / ' + steps.length;
      if (bar) bar.style.width = (75 * i / (steps.length - 1)) + '%';
    }
    steps.forEach(function (s, k) { s.addEventListener('click', function () { ir(k); }); });
    if (prev) prev.addEventListener('click', function () { ir(i - 1); });
    if (next) next.addEventListener('click', function () { ir(i + 1); });
    ir(0);
  }

  /* ───────────── Pestañas de ingredientes ───────────── */
  function ingredientes(root) {
    var tabs = $$('.sc-ing__tab', root), panels = $$('.sc-ing__panel', root), imgs = $$('.sc-ing__media img', root);
    function ir(n) {
      tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === n); t.setAttribute('aria-selected', k === n); });
      panels.forEach(function (p, k) { p.classList.toggle('is-on', k === n); });
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === n); });
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { ir(k); }); });
    ir(0);
  }

  /* ───────────── Reseñas: «ver completa» y páginas ───────────── */
  function resenas(root) {
    $$('.sc-rv__text', root).forEach(function (t) {
      var more = t.nextElementSibling;
      if (!more || !more.classList.contains('sc-rv__more')) return;
      requestAnimationFrame(function () {
        if (t.scrollHeight <= t.clientHeight + 2) { more.remove(); return; }
        more.hidden = false;
      });
      more.addEventListener('click', function () { t.classList.remove('is-clamped'); more.remove(); });
    });
    var pages = $$('.sc-rv__page', root), btns = $$('.sc-rv__pag button', root);
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () {
        pages.forEach(function (p, j) { p.classList.toggle('is-on', j === k); });
        btns.forEach(function (x, j) { x.classList.toggle('is-on', j === k); });
        var top = root.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ───────────── Cuenta atrás hasta medianoche del visitante ───────────── */
  function cuentaAtras() {
    var els = $$('[data-sc-countdown]');
    if (!els.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tic() {
      var now = new Date(), fin = new Date(now);
      fin.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((fin - now) / 1000));
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      els.forEach(function (e) { e.textContent = txt; });
    }
    tic();
    setInterval(tic, 1000);
  }

  /* ───────────── Fechas de entrega: «unos 7 días» → de +5 a +9 ───────────── */
  function fechasEntrega() {
    var els = $$('[data-sc-entrega]');
    if (!els.length) return;
    var dias = ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'];
    var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    els.forEach(function (e) {
      var d = new Date();
      d.setDate(d.getDate() + parseInt(e.getAttribute('data-sc-entrega'), 10));
      e.textContent = dias[d.getDay()] + ' ' + d.getDate() + ' de ' + meses[d.getMonth()];
    });
  }

  /* ───────────── Anclas suaves ───────────── */
  function anclas() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-sc-goto]');
      if (!a) return;
      var t = document.querySelector(a.getAttribute('data-sc-goto'));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });
  }

  /* ───────────── Barra fija: aparece cuando el botón de compra ya no se ve ───────────── */
  function barraFija() {
    var bar = $('.sc-sticky'), atc = $('#sc-packs') || $('.sc-atc');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    // El tema pone content-visibility en las secciones y eso encierra a los position:fixed: al body
    document.body.appendChild(bar);
    var visible = true;
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; pintar(); }, { threshold: 0 }).observe(atc);
    function pintar() { bar.classList.toggle('is-on', !visible && window.scrollY > 500); }
    window.addEventListener('scroll', pintar, { passive: true });
  }

  /* ───────────── Packs (clon del bloque Kaching de la original) ───────────── */
  function packs(root) {
    var cfgEl = $('script[type="application/json"][data-sc-cfg]', root);
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    var cards = $$('.sc-pack', root);
    var scratch = $('.sc-scratch', root);
    var hint = $('.sc-packs__hint', root);
    var atc = $('.sc-atc', root);
    var msg = $('.sc-atc__msg', root);
    var sel = cards.filter(function (c) { return c.classList.contains('is-selected'); })[0] || cards[0];

    function oculto(c) { return scratch && scratch.contains(c) && !scratch.classList.contains('is-revealed'); }
    function regalos() {
      // Mientras la lámina tapa el pack marcado, los regalos siguen bloqueados (como en la original)
      var u = oculto(sel) ? 0 : parseInt(sel.getAttribute('data-units'), 10);
      $$('.sc-gift', root).forEach(function (g) { g.classList.toggle('is-on', u >= parseInt(g.getAttribute('data-min'), 10)); });
    }
    function elegir(c) {
      sel = c;
      cards.forEach(function (x) { x.classList.toggle('is-selected', x === c); x.setAttribute('aria-checked', x === c); });
      regalos();
      if (hint) hint.classList.remove('is-on');
      root.dispatchEvent(new CustomEvent('sc:pack', { bubbles: true, detail: { units: c.getAttribute('data-units') } }));
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('.sc-select') || e.target.closest('.sc-upsell')) return;
        if (oculto(c)) return;
        elegir(c);
      });
      c.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === c && !oculto(c)) { e.preventDefault(); elegir(c); }
      });
    });

    $$('.sc-upsell', root).forEach(function (u) {
      u.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var c = u.closest('.sc-pack');
        if (oculto(c)) return;
        if (c !== sel) {
          elegir(c);
          if (u.classList.contains('is-on')) return;
        }
        var on = !u.classList.contains('is-on');
        u.classList.toggle('is-on', on);
        u.setAttribute('aria-pressed', on);
      });
    });

    $$('.sc-select', root).forEach(function (s) {
      var btn = $('.sc-select__btn', s);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var abrir = !s.classList.contains('is-open');
        $$('.sc-select.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        s.classList.toggle('is-open', abrir);
        btn.setAttribute('aria-expanded', abrir);
      });
      $$('.sc-select__opt', s).forEach(function (o) {
        o.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          s.setAttribute('data-variant', o.getAttribute('data-variant'));
          $('.sc-select__sw', btn).src = $('img', o).src;
          $('.sc-select__name', btn).textContent = o.getAttribute('data-name');
          $$('.sc-select__opt', s).forEach(function (x) { x.setAttribute('aria-selected', x === o); });
          s.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    });
    document.addEventListener('click', function () { $$('.sc-select.is-open').forEach(function (o) { o.classList.remove('is-open'); }); });

    /* Tarjeta de rasca: lámina dorada en canvas; se descubre al rascar ~40 % o con el teclado */
    var revelar = function () {};
    if (scratch) {
      var cover = $('.sc-scratch__cover', scratch), cv = $('canvas', cover), ctx = cv.getContext('2d');
      var label = $('.sc-scratch__label', scratch), hand = $('.sc-scratch__hand', scratch);
      var listo = false, trazos = 0, ultimo = null, rascando = false;
      var pintarLamina = function () {
        var r = cover.getBoundingClientRect();
        if (!r.width) return;
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        cv.width = r.width * dpr; cv.height = r.height * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        var g = ctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#bf9640'); g.addColorStop(0.22, '#f1d98c'); g.addColorStop(0.45, '#c79a3a');
        g.addColorStop(0.7, '#f4dc93'); g.addColorStop(1, '#b4852c');
        ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
        var rg = ctx.createRadialGradient(r.width * 0.35, r.height * 0.4, 10, r.width * 0.35, r.height * 0.4, r.width * 0.5);
        rg.addColorStop(0, 'rgba(255,255,255,.28)'); rg.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = rg; ctx.fillRect(0, 0, r.width, r.height);
        for (var k = 0; k < 1600; k++) {
          ctx.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.22) + ')';
          ctx.fillRect(Math.random() * r.width, Math.random() * r.height, 1.3, 1.3);
        }
      };
      revelar = function (porBoton) {
        if (listo) return;
        listo = true;
        scratch.classList.add('is-revealing');
        setTimeout(function () { scratch.classList.add('is-revealed'); scratch.classList.remove('is-revealing'); regalos(); }, 460);
        if (porBoton && hint) hint.classList.add('is-on');
      };
      var pos = function (e) {
        var r = cv.getBoundingClientRect(), t = e.touches ? e.touches[0] : e;
        return { x: t.clientX - r.left, y: t.clientY - r.top };
      };
      var rascar = function (a, b) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineWidth = 44; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
        ctx.beginPath(); ctx.arc(b.x, b.y, 22, 0, Math.PI * 2); ctx.fill();
      };
      var medir = function () {
        var w = cv.width, h = cv.height, d = ctx.getImageData(0, 0, w, h).data, vacio = 0, n = 0;
        for (var y = 0; y < h; y += 8) for (var x = 0; x < w; x += 8) { n++; if (d[(y * w + x) * 4 + 3] < 40) vacio++; }
        if (vacio / n > 0.4) revelar(false);
      };
      var inicio = function (e) {
        if (listo) return;
        rascando = true; ultimo = pos(e); rascar(ultimo, ultimo);
        if (label) label.style.opacity = '0';
        if (hand) hand.style.display = 'none';
        e.preventDefault();
      };
      var mover = function (e) {
        if (!rascando || listo) return;
        var p = pos(e); rascar(ultimo, p); ultimo = p;
        if (++trazos % 6 === 0) medir();
        e.preventDefault();
      };
      var fin = function () { if (rascando) { rascando = false; medir(); } };
      cv.addEventListener('mousedown', inicio); cv.addEventListener('touchstart', inicio, { passive: false });
      window.addEventListener('mousemove', mover); cv.addEventListener('touchmove', mover, { passive: false });
      window.addEventListener('mouseup', fin); window.addEventListener('touchend', fin);
      var kb = $('.sc-scratch__btn', scratch);
      if (kb) kb.addEventListener('click', function () { revelar(false); });
      pintarLamina();
      if ('ResizeObserver' in window) new ResizeObserver(function () { if (!listo && !rascando) pintarLamina(); }).observe(cover);
    }

    regalos();

    if (!atc) return;
    atc.addEventListener('click', function (e) {
      e.preventDefault();
      if (msg) msg.textContent = '';
      // El pack marcado por defecto (2+1) vive debajo de la lámina: nunca se agrega sin que el
      // cliente lo haya visto. El primer clic descubre las ofertas; el segundo compra.
      if (oculto(sel)) {
        revelar(true);
        var t = scratch.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: t, behavior: 'smooth' });
        return;
      }
      var cuenta = {}, orden = [];
      $$('.sc-select', sel).forEach(function (s) {
        var v = s.getAttribute('data-variant');
        if (!cuenta[v]) { cuenta[v] = 0; orden.push(v); }
        cuenta[v]++;
      });
      var items = orden.map(function (v) { return { id: parseInt(v, 10), quantity: cuenta[v] }; });
      $$('.sc-upsell.is-on', sel).forEach(function (u) { items.push({ id: parseInt(u.getAttribute('data-variant'), 10), quantity: 1 }); });
      if (parseInt(sel.getAttribute('data-units'), 10) >= 3 && cfg.regalo) items.push({ id: parseInt(cfg.regalo, 10), quantity: 1 });

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      atc.setAttribute('aria-busy', 'true');
      var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'No se pudo agregar');
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sc-packs', cartData: res });
          }
          if (cart && cart.renderContents && res.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          if (msg) msg.textContent = err.message || 'No se pudo agregar al carrito. Inténtalo de nuevo.';
        })
        .finally(function () { atc.removeAttribute('aria-busy'); });
    });
  }

  /* ───────────── Cifras que cuentan al entrar en pantalla ───────────── */
  function contadores() {
    var els = $$('[data-sc-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, fin = parseFloat(el.getAttribute('data-sc-count')) || 0, t0 = null;
        if (!fin) return;
        var paso = function (t) {
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1200);
          el.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(paso);
        };
        el.textContent = '0';
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() {
    $$('[data-sc-carousel]').forEach(carrusel);
    $$('[data-sc-timeline]').forEach(lineaTiempo);
    $$('[data-sc-ingredientes]').forEach(ingredientes);
    $$('[data-sc-resenas]').forEach(resenas);
    $$('[data-sc-packs]').forEach(packs);
    videos();
    cuentaAtras();
    fechasEntrega();
    anclas();
    barraFija();
    contadores();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
